<app-modal [open]="active" [name]="'submit-for-review'" (close)="closeDialog()">
  <div modal-header>Submit This {{ dialogTitle }} For Review?</div>
  <div modal-body>
    <p>
      This action will send this
      {{ dialogMessage }} for review.
      <br />
      <br />
      Do you wish to continue?
    </p>

    <ng-container *ngIf="deliverableDocuments?.length > 0">
      <h3>{{ status === "ACTIVE" ? "Deliverable" : "Revised" }} Documents</h3>

      <div class="submit-for-review-dialog__documents">
        <div
          class="submit-for-review-dialog__documents-item"
          *ngFor="let document of deliverableDocuments"
        >
          <p class="submit-for-review-dialog__documents-title">
            {{ document.fileName }}
          </p>
          @switch (document.type) { @case ('DELIVERABLE') {
          <p class="submit-for-review-dialog__documents-description">
            Deliverable
          </p>
          } @case ('REVISION') {
          <p class="submit-for-review-dialog__documents-description">
            Revision
          </p>
          }}
        </div>
      </div>
    </ng-container>

    <div class="submit-for-review-dialog__summary">
      <div class="submit-for-review-dialog__summary-item">
        <p class="submit-for-review-dialog__summary-label">Service Type</p>
        <p class="submit-for-review-dialog__summary-value">
          {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
        </p>
      </div>
      <div class="submit-for-review-dialog__summary-item">
        <p class="submit-for-review-dialog__summary-label">Location</p>
        <p class="submit-for-review-dialog__summary-value">
          <span *ngIf="address?.streetAddress"
            >{{ address?.streetAddress }}<br /></span
          >{{ address?.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="submit-for-review-confirm"
    (click)="submit()"
    [disabled]="isSubmitting"
  >
    Submit for {{ status === "ACTIVE" ? "Review" : "Revision" }}
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="submit-for-review-cancel"
    (click)="closeDialog()"
  >
    Back
  </button>
</app-modal>

<review-order-submitted-dialog
  [active]="isReviewOrderSubmitted"
  [documents]="documents"
  [siteType]="siteType"
  [siteSubType]="siteSubType"
  [address]="address"
  (modalClosed)="toggleReviewCompletedClosed()"
  [ngClass]="{ 'documents-dialog--active': isReviewOrderSubmitted }"
></review-order-submitted-dialog>
